'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { ArrowRightIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Fragment, useState } from 'react';
import { ModuleSidebar } from '@/app/baza/(collection)/_components/ModuleSidebar';
import { ArticleStateProvider } from '@/app/baza/(collection)/_utils/ArticleStateContext/ArticleStateContext';
import { Button } from '@/frontend/design-system/actions/Button';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { NavbarSection } from '@/frontend/design-system/navigation/Navbar';
import { Label1 } from '@/frontend/design-system/typography/Label';
import { LogoutButtonMobile } from './LogoutButton';
export function NavbarMobile(t0) {
  const $ = _c(21);
  const {
    userLogged
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.split("/");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const segments = t1;
  let isOnArticlePage = false;
  if (segments.length > 3 && segments[2] !== "manage") {
    isOnArticlePage = !!segments[3];
  }
  const hrefRedirect = `redirectTo=${encodeURIComponent(pathname)}`;
  const [open, setOpen] = useState(false);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" className="inline-flex items-center justify-center rounded-md p-2.5 text-contentPrimary" onClick={() => setOpen(true)}><Bars3Icon className="h-6 w-6 text-contentInverseSecondary" /></button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/25" /></TransitionChild>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex lg:flex-1"><Link href="/"><Image src="/logos/logo-full-horizontal-dark.svg" alt="logo" width={160} height={20} className="hidden dark:block" /><Image src="/logos/logo-full-horizontal-light.svg" alt="logo" width={160} height={20} className="dark:hidden" /></Link></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center justify-between">{t5}<button type="button" className="rounded-md p-2.5 text-contentPrimary" onClick={() => setOpen(false)}><XMarkIcon className="h-6 w-6 text-contentInverseSecondary" /></button></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isOnArticlePage) {
    t7 = isOnArticlePage && <div className="space-y-2"><ModuleSidebar /></div>;
    $[7] = isOnArticlePage;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Link href="/baza" className="flex items-center gap-2"><Label1 className="border-contentColorPrimary border-b text-contentColorPrimary">Baza wiedzy</Label1><ArrowRightIcon className="h-4 w-4 text-contentColorPrimary" /></Link>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="/" className="flex items-center gap-2"><Label1 className="border-contentColorPrimary border-b text-contentColorPrimary">Strona marketingowa</Label1><ArrowRightIcon className="h-4 w-4 text-contentColorPrimary" /></Link>;
    t10 = <Divider />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== hrefRedirect || $[13] !== userLogged) {
    t11 = userLogged ? <LogoutButtonMobile /> : <div className="space-y-3"><Button href={`/auth/register?${hrefRedirect}`} className="w-full">Zarejestruj się</Button><Button href={`/auth/login?${hrefRedirect}`} outline={true} className="w-full">Zaloguj się</Button></div>;
    $[12] = hrefRedirect;
    $[13] = userLogged;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t7) {
    t12 = <Dialog as="div" className="lg:hidden" onClose={t3}>{t4}<TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="-translate-x-full opacity-0" enterTo="translate-x-0 opacity-100" leave="ease-in duration-200" leaveFrom="translate-x-0 opacity-100" leaveTo="-translate-x-full opacity-0"><DialogPanel className="fixed inset-y-0 left-0 z-10 w-full max-w-sm overflow-y-auto bg-backgroundSecondary px-6 py-6">{t6}<div className="flex flex-col gap-6 py-6">{t7}{t8}{t9}{t10}{t11}</div></DialogPanel></TransitionChild></Dialog>;
    $[15] = t11;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== open || $[19] !== t12) {
    t13 = <ArticleStateProvider><NavbarSection>{t2}<Transition show={open} as={Fragment}>{t12}</Transition></NavbarSection></ArticleStateProvider>;
    $[18] = open;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}